import 'css-chunksrc/client/scenes/milestone/datesPickers/styles.scss';export default {
  "dateForm": "_dateForm_1f2ms_1",
  "group": "_group_1f2ms_7",
  "wrapper": "_wrapper_1f2ms_14",
  "icon": "_icon_1f2ms_22",
  "title": "_title_1f2ms_32",
  "input": "_input_1f2ms_39",
  "calendar": "_calendar_1f2ms_58",
  "datesWrapper": "_datesWrapper_1f2ms_66",
  "completionDate": "_completionDate_1f2ms_74"
};